import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
const StatisticsBoxes = ({ arrayOfStatistics }) => {
  return (
    <Container>
      <Row>
        {/* Loop over the arrayOfStatistics array*/}
        {arrayOfStatistics.map((statistic, index) => {
          // Destructure title and value from each statistic object of array
          const { title, value } = statistic;
          return (
            <Col
              sm={12}
              lg={4}
              className="mb-2 mb-md-4 d-flex justify-content-center"
              key={index}
            >
              <div className="summary-card d-flex flex-lg-column  justify-content-between">
                <p
                  style={{ marginBottom: 0 }}
                  className="summary-card-title ms-3 m-lg-0"
                >
                  {title}
                </p>
                <h4 className="summary-card-value text-celadon me-4 mb-0 m-lg-0">
                  {value}
                </h4>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};
export default StatisticsBoxes;
